import React from "react";
import { useSelector } from "react-redux";
import IndexApp from "../../Components/IndexApp";
import { DV2 } from "../DeclarationV2/theme";
import DocumentsV2 from "./DocumentsV2";

/**
 * « Mes documents » du prof, version repensée (maquette 9a). L'ancienne page
 * (`TeachrDocuments`, `DocumentSpace`) reste dans le code, la vue client est
 * inchangée.
 */
const TeachrDocumentsV2 = () => {
    const teachr = useSelector((state: any) => state.user.currentUser?.teachr);
    return (
        <IndexApp
            navBar={{ index: 3 }}
            teachr={teachr}
            component={
                <main className="px-4" style={{ background: DV2.pageBg, minHeight: "calc(100vh - 64px)" }}>
                    {teachr?.id ? <DocumentsV2 teachrId={teachr.id} /> : null}
                </main>
            }
        />
    );
};

export default TeachrDocumentsV2;
